import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPlan: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="plan, process, connect, path"><path d="M15 6.5H8.81314C7.00339 6.5 6.38405 8.91123 7.96978 9.78338L16.0302 14.2166C17.616 15.0888 16.9966 17.5 15.1869 17.5H9" stroke="currentColor" strokeWidth="1.5"/><path d="M14.75 9.25V3.75H20.25V9.25H14.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M3.75 20.25V14.75H9.25V20.25H3.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconPlan;
